enum StagesByNumber {
  "A1 - A3 - Production" = 0,
  "A4 - Production" = 4,
  "A5 - Installation",
  "B1 - Use",
  "B2 - Maintenance",
  "B3 - Repair",
  "B4 - Replacement",
  "B5 - Refurbishment",
  "B6 - Operational Energy Use",
  "B7 - Operational Water User",
  "C1 - Demolition",
  "C2 - Transport",
  "C3 - Waste processing",
  "C4 - Disposal",
  "D - Reuse, recovery, recycling",
}

enum StagesByEnum {
  A1A3 = "A1 - A3 - Production",
  A4 = "A4 - Production",
  A5 = "A5 - Installation",
  B1 = "B1 - Use",
  B2 = "B2 - Maintenance",
  B3 = "B3 - Repair",
  B4 = "B4 - Replacement",
  B5 = "B5 - Refurbishment",
  B6 = "B6 - Operational Energy Use",
  B7 = "B7 - Operational Water User",
  C1 = "C1 - Demolition",
  C2 = "C2 - Transport",
  C3 = "C3 - Waste processing",
  C4 = "C4 - Disposal",
  D = "D - Reuse, recovery, recycling",
}

const getStageTooltipByEnum = (stageType: string): string => {
  return StagesByEnum[stageType as keyof typeof StagesByEnum];
};

const getStageTooltip = (stageType: number): string => {
  return StagesByNumber[stageType];
};

export { getStageTooltip, getStageTooltipByEnum, StagesByNumber, StagesByEnum };
